import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { v4 as uuidv4 } from 'uuid';
import CancelButton from '~/modules/common/components/CancelButton';
import useModalFocusHandler from '../hooks/useModalFocusHandler';

const dialogTitleId = 'unsaved-changes-dialog-title';
const dialogDescriptionId = 'unsaved-changes-dialog-description';

export const UnsavedChangesWarningDialog = ({ closeParent, onClose, open }) => {
  const dialogId = useRef(`dialog-${uuidv4()}`);

  useModalFocusHandler({
    isOpen: open,
    containerQuerySelector: `[data-dialog-id="${dialogId.current}"] .MuiDialog-container`
  });

  const handleDiscardChanges = useCallback(() => {
    onClose();
    closeParent();
  }, [closeParent, onClose]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby={dialogTitleId}
      aria-describedby={dialogDescriptionId}
      data-dialog-id={dialogId.current}
    >
      <DialogTitle disableTypography id={dialogTitleId}>
        <Typography role="presentation" variant="h6">
          <FormattedMessage id="unsavedChangesWarningDialog.title" />
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id={dialogDescriptionId}>
          <Typography variant="caption" color="textSecondary">
            <FormattedMessage id="unsavedChangesWarningDialog.alertText" />
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <CancelButton autoFocus variant="text" onClick={onClose} />
        <Button variant="text" color="primary" onClick={handleDiscardChanges}>
          <FormattedMessage id="unsavedChangesWarningDialog.discardAndClose" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
UnsavedChangesWarningDialog.propTypes = {
  closeParent: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

export default UnsavedChangesWarningDialog;
